import { render, staticRenderFns } from "./inactiva.vue?vue&type=template&id=6db61ba0&scoped=true&"
import script from "./inactiva.vue?vue&type=script&lang=js&"
export * from "./inactiva.vue?vue&type=script&lang=js&"
import style0 from "./inactiva.vue?vue&type=style&index=0&id=6db61ba0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db61ba0",
  null
  
)

export default component.exports